import validate from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.21.10_@oxc-project+types@0.140.0_@parcel+watcher@2.5.6_@types+node@24.6.1_@vue+c_01e2ab469303ae64dc334d479b301b0c/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/middleware/auth.global.js";
import manifest_45route_45rule from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.21.10_@oxc-project+types@0.140.0_@parcel+watcher@2.5.6_@types+node@24.6.1_@vue+c_01e2ab469303ae64dc334d479b301b0c/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "company-guard": () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/middleware/companyGuard.js")
}